module.exports = "/static-assets/_next/static/images/laptop_2-f38b8712626452998b6b09a1e517bb59.png";